import { consentHeaders, hasConsent } from "./consent.ts";

/**
 * Cookielose Nutzungsstatistik, nur mit Einwilligung (consent.ts): Seitenaufrufe gehen an den
 * eigenen Server (/api/track), der sie mit gekürzter IP an Matomo weiterreicht. Spielereignisse
 * (Raum erstellt, Partie gestartet …) meldet der Server selbst.
 */

const ROOM_PATH = /^\/[A-Za-z0-9]{6}\/?$/;

/** Pfad und Titel für die Statistik; null = nicht erfassen (Admin-Backend). */
export function pageFor(path: string): { path: string; title: string } | null {
  if (path === "/admin" || path.startsWith("/admin/")) return null;
  if (path === "/") return { path: "/", title: "numbet – Startseite" };
  const known: Record<string, string> = {
    "/regeln": "Regeln",
    "/neu": "Raum erstellen",
    "/beitreten": "Raum beitreten",
    "/impressum": "Impressum",
    "/nutzungsbedingungen": "Nutzungsbedingungen",
    "/datenschutz": "Datenschutz",
  };
  const title = known[path];
  if (title) return { path, title: `numbet – ${title}` };
  if (ROOM_PATH.test(path)) return { path: "/raum", title: "numbet – Raum" };
  return { path, title: "numbet – Seite nicht gefunden" };
}

function send(body: object): void {
  if (!hasConsent()) return;
  void fetch("/api/track", {
    method: "POST",
    headers: { "content-type": "application/json", ...consentHeaders() },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => undefined);
}

export function trackPageView(path: string): void {
  const page = pageFor(path);
  if (page) send(page);
}

/** Nur Kategorien, die der Server vom Browser annimmt (CLIENT_EVENT_CATEGORIES). */
export function trackShare(action: "Link kopiert" | "Teilen-Dialog"): void {
  send({ path: "/raum", event: { category: "Teilen", action } });
}
